// @flow

import { observer } from "mobx-react";
import React from "react";

import "./VideoPlayerPreview.scss";

type Props = {
    thumbnail: string,
    onPlay?: Function,
    showPlayButton?: boolean
};

@observer
export default class VideoPlayerPreview extends React.Component<Props> {
    render() {
        const classes = ["VideoPlayerPreview"];
        if (this.props.showPlayButton) {
            classes.push("VideoPlayerPreview--with-play-button");
        }

        return (
            <div className={classes.join(" ")} onClick={this.props.onPlay}>
                <div className="VideoPlayerPreview__thumbnail">
                    <img src={this.props.thumbnail} alt="Video" />
                </div>

                {this.renderPlayButton()}
            </div>
        );
    }

    renderPlayButton() {
        return (
            <div className="VideoPlayerPreview__icon">
                <i className="glyphicon glyphicon-play" />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/VideoPlayerPreview/VideoPlayerPreview.js